import { render } from "./Monitor.vue?vue&type=template&id=3f32d8c4"
import script from "./Monitor.vue?vue&type=script&lang=js"
export * from "./Monitor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__